import { CommerceConsumerOnlineActions } from '../actions/commerce-consumer-online-actions.mjs';

const commerceOnlineConsumerReducer = (state, action) => {
  switch (action.type) {
    case CommerceConsumerOnlineActions.DEEP_LINK_CHECK_FINISHED: {
      return {
        ...state,
        commerceAppIsReady: true
      }
    }

    default:
      return state;
  }
}

export default commerceOnlineConsumerReducer;
